module.exports = __webpack_public_path__ + "static/img/Sf.f147a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Sf.png
// module id = A4NY
// module chunks = 0